module.exports = __webpack_public_path__ + "img/vmc_aniv20_24Aug2021.c1e1788f.jpg";